// frontend/src/components/athleteEditor/SectionIndex.jsx
import React from 'react';

// sections: [{ id, label }]. Mono uppercase anchor links; the active link
// (driven by AdminAthleteEditPanel's useActiveSection IntersectionObserver)
// gets the accent left-border + dark text treatment.
//
// extraItems: [{ id, label }] rendered below a separator rule — these are not
// scroll-spy targets but view switches (e.g. "Measurables" swaps the editor
// body for the verify ledger). Their active state is driven by activeExtra and
// clicks call onExtra(id).
export default function SectionIndex({ sections, activeId, onJump, extraItems = [], onExtra, activeExtra }) {
  return (
    <nav className="ae-secindex">
      {sections.map(s => (
        <a key={s.id} href={`#${s.id}`} onClick={e => { e.preventDefault(); onJump(s.id); }}
          className={`ae-secindex__link${activeId === s.id ? ' ae-secindex__link--active' : ''}`}>
          {s.label}
        </a>
      ))}
      {extraItems.length > 0 && <div className="ae-secindex__sep" role="separator" aria-hidden="true" />}
      {extraItems.map(s => (
        <a key={s.id} href={`#${s.id}`} onClick={e => { e.preventDefault(); onExtra(s.id); }}
          className={`ae-secindex__link${activeExtra === s.id ? ' ae-secindex__link--active' : ''}`}>
          {s.label}
        </a>
      ))}
    </nav>
  );
}
